export function CountryBadge({ color, label }) {
    return (
        <div className="flex items-center gap-2 bg-white/70 backdrop-blur-md border border-navy/5 px-4 py-2 rounded-full shadow-sm">
            <span className={`w-2 h-2 rounded-full ${color}`} />
            <span className="font-manrope text-label-caps uppercase text-on-surface">
                {label}
            </span>
        </div>
    );
}

export function StatCard({ value, label }) {
    return (
        <div className="p-6 bg-white rounded-xl border border-outline-variant/30 text-center shadow-sm">
            <div className="text-h2 font-manrope font-semibold text-primary-container">
                {value}
            </div>
            <div className="text-label-caps font-manrope text-on-surface-variant mt-1">
                {label}
            </div>
        </div>
    );
}

export function ServiceCard({ icon, title, description, featured = false }) {
    return (
        <div
            className={`bg-white/70 backdrop-blur-md p-8 rounded-2xl transition-all duration-300 group hover:-translate-y-2
        ${featured
                    ? "border-2 border-secondary/20"
                    : "border border-navy/5"
                }`}
        >
            <span className="material-symbols-outlined text-secondary text-4xl mb-6 block">
                {icon}
            </span>
            <h3 className="font-manrope text-h3 mb-4 group-hover:text-secondary transition-colors">
                {title}
            </h3>
            <p className="font-manrope text-body-sm text-on-surface-variant">
                {description}
            </p>
        </div>
    );
}

export function BlogCard({ image, tag, tagStyle, date, title, href = "#" }) {
    return (
        <article className="bg-white rounded-2xl overflow-hidden shadow-sm border border-outline-variant/20 hover:shadow-xl transition-all">
            <img
                src={image}
                alt={title}
                className="w-full h-48 object-cover"
            />
            <div className="p-6">
                <div className="flex items-center gap-4 mb-4">
                    <span className={`px-3 py-1 rounded-full text-[10px] font-bold font-manrope ${tagStyle}`}>
                        {tag}
                    </span>
                    <span className="font-manrope text-body-sm text-on-surface-variant">
                        {date}
                    </span>
                </div>
                <h3 className="font-manrope text-h3 mb-4 line-clamp-2">{title}</h3>
                <a
                    href={href}
                    className="text-secondary font-bold text-sm inline-flex items-center gap-1 group font-manrope"
                >
                    Read More
                    <span className="material-symbols-outlined text-sm group-hover:translate-x-1 transition-transform">
                        chevron_right
                    </span>
                </a>
            </div>
        </article >
    );
}

export function ContactInfoItem({ icon, label, value }) {
    return (
        <div className="flex items-center gap-6">
            <div className="w-12 h-12 bg-white/10 rounded-full flex items-center justify-center flex-shrink-0">
                <span className="material-symbols-outlined text-secondary-container">
                    {icon}
                </span>
            </div>
            <div>
                <p className="font-manrope text-label-caps opacity-60">{label}</p>
                <p className="font-manrope font-bold">{value}</p>
            </div>
        </div>
    );
}

export function FormField({ label, children }) {
    return (
        <div className="flex flex-col gap-2">
            <label className="font-manrope text-label-caps text-on-surface-variant">
                {label}
            </label>
            {children}
        </div>
    );
}

export function FooterLink({ href = "#", children }) {
    return (
        <a
            href={href}
            className="font-manrope text-sm text-slate-500 hover:text-navy dark:hover:text-white transition-all duration-200 hover:-translate-y-0.5 inline-block"
        >
            {children}
        </a >
    );
}